import InterestCalculatedOnBalanceType from "@/models/Products/InterestCalculatedOnBalanceType";

export default (calculatedOn: InterestCalculatedOnBalanceType) => {
    let returnVal = "Undefined";
    switch (calculatedOn) {
        case InterestCalculatedOnBalanceType.AverageDailyBalance:
            returnVal = "Average Balance"
            break;
        case InterestCalculatedOnBalanceType.EndOfDayBalance:
            returnVal = "End of Day Balance"
            break;
        case InterestCalculatedOnBalanceType.MinimumBalance:
            returnVal = "Minimum Balance"
            break;
    }
    return returnVal;
}